var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCameraWarning = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6506 12.8385H9.3494L9.01205 7H10.988L10.6506 12.8385ZM10 16C9.44578 16 9 15.5411 9 14.9547C9 14.3683 9.44578 13.8839 10 13.8839C10.5542 13.8839 11 14.3683 11 14.9547C11 15.5411 10.5542 16 10 16Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 10L22 7V17L18 14",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 4.5,
    width: 15,
    height: 15,
    rx: 1.5,
    stroke: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCameraWarning, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/CameraWarning.07ffd7b2.svg";
export { ForwardRef as ReactComponent };